import * as React from 'react';
import { Link } from '../Link';

interface ILegalDocumentsCountrysideProps {
  onLinkClick(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const LegalDocumentsCountryside: React.FC<ILegalDocumentsCountrysideProps> = ({ onLinkClick }) => (
  <>
    ЦИАН — база данных о недвижимости. Использование сайта означает согласие с{' '}
    <Link href="/legal-documents/pravila_polzovaniya_sajtom_cian_0/" theme="accent" onClick={onLinkClick}>
      Пользовательским соглашением
    </Link>
    ,{' '}
    <Link href="/legal-documents/politika_konfidencialnosti_0/" theme="accent" onClick={onLinkClick}>
      Политикой конфиденциальности ЦИАН
    </Link>{' '}
    и{' '}
    <Link
      href="/legal-documents/usloviya_ispolzovaniya_servisa_zagorodnoe_stroitelstvo_0/"
      theme="accent"
      onClick={onLinkClick}
    >
      Условиями сервиса «Загородное строительство»
    </Link>
    . Оплачивая лицензионный платеж, вы принимаете{' '}
    <Link href="/legal-documents/licenzionnoe_soglashenie_0/" theme="accent" onClick={onLinkClick}>
      Лицензионное соглашение
    </Link>
    .
  </>
);
